/**
 * navigation.js
 * script add custom classes to menu controlers
 * use structure
 *
 * <div class="navigation">
 * 	<button class="hamburger"></button>
 * 	<nav class="display"><?php wp_nav_menu(); ?></nav>
 * </div>
 *
 */
// window.onresize = function () {
//   location.reload();
// };

if (window.matchMedia("(max-width: 1280px)").matches) {
  (function () {
    const hamburger = document.querySelector(".navigation .hamburger");
    const menu = document.querySelector(".navigation .display");
    const body = document.querySelector("body");

    hamburger.addEventListener("click", () => {
      hamburger.classList.toggle("is-active");
      body.classList.toggle("overflow");
      menu.classList.toggle("show");
    });

    // submenu
    let submenu = document.querySelectorAll(".menu-item-has-children");

    // add carret to submenu
    submenu.forEach((element) => {
      element.innerHTML +=
        '<button class="carret"><svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21.0002 0C16.8468 0 12.7867 1.23163 9.33328 3.53914C5.87984 5.84665 3.18822 9.1264 1.59878 12.9636C0.00934311 16.8009 -0.406527 21.0233 0.403763 25.0969C1.21405 29.1705 3.21411 32.9123 6.15101 35.8492C9.08791 38.7861 12.8298 40.7862 16.9034 41.5965C20.977 42.4068 25.1994 41.9909 29.0366 40.4015C32.8738 38.812 36.1536 36.1204 38.4611 32.667C40.7686 29.2135 42.0002 25.1534 42.0002 21C41.9896 15.4337 39.7736 10.0985 35.8377 6.16255C31.9017 2.22659 26.5665 0.0106736 21.0002 0ZM29.0772 22.6154H16.8204L20.9195 26.7144C21.2216 27.0172 21.3912 27.4275 21.3912 27.8553C21.3912 28.283 21.2216 28.6933 20.9195 28.9961C20.7691 29.1475 20.5895 29.2667 20.3917 29.3465C20.1938 29.4263 19.9818 29.4651 19.7685 29.4606C19.5583 29.4648 19.3494 29.4257 19.1549 29.3458C18.9604 29.2659 18.7844 29.1469 18.6377 28.9961L11.7926 22.151C11.6404 21.9996 11.5172 21.8217 11.4291 21.626C11.2674 21.2243 11.2674 20.7757 11.4291 20.374C11.5172 20.1783 11.6404 20.0004 11.7926 19.849L18.6377 13.0038C18.945 12.7254 19.3476 12.5758 19.7622 12.586C20.1767 12.5962 20.5714 12.7655 20.8647 13.0587C21.1579 13.3519 21.3271 13.7466 21.3373 14.1612C21.3475 14.5757 21.1979 14.9783 20.9195 15.2856L16.8204 19.3846H29.0772C29.5056 19.3846 29.9165 19.5548 30.2194 19.8577C30.5224 20.1607 30.6926 20.5716 30.6926 21C30.6926 21.4284 30.5224 21.8393 30.2194 22.1422C29.9165 22.4452 29.5056 22.6154 29.0772 22.6154Z" fill="#F6A841"/></svg></button>';
    });

    function activeMenuLink(item) {
      let menu = document.querySelector("#menu-main-menu");
      let activeMenu = document.querySelectorAll(".menu-item-has-children");

      if (item.classList.contains("menu-item-has-children--active")) {
        item.classList.remove("menu-item-has-children--active");
        menu.classList.remove("show-sub");
        hamburger.classList.remove("is-sub-active");
      } else {
        activeMenu.forEach((item) =>
          item.classList.remove("menu-item-has-children--active")
        );
        item.classList.add("menu-item-has-children--active");
        menu.classList.add("show-sub");
        hamburger.classList.add("is-sub-active");
      }
    }

    submenu.forEach((item) =>
      item.addEventListener("click", (e) => {
        activeMenuLink(item);
      })
    );
  })();
}
